import { render } from "./Carousel.vue?vue&type=template&id=40efa57a"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"

import "./Carousel.vue?vue&type=style&index=0&id=40efa57a&lang=css"

import exportComponent from "/home/runner/work/Portfolio/Portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__